const e = "headerImage_OhCJG", a = {
  headerImage: e
};
export {
  a as default,
  e as headerImage
};
//# sourceMappingURL=kioskHeaderImg.module.scss.js.map
